<template>

  <main>
    <div class="main-container">

      <b-alert v-model="error" variant="danger" dismissible>
        {{ msg_alert }}
      </b-alert>

      <div class="h-100">

        <b-button href="/create/evenement" variant="primary"> Nouvel évènement</b-button>

        <div class="mt-4">
          <b-card-group deck>
            <b-card v-for='ev in evenements'>
              <b-card-text>
                <div class="d-flex">
                  <p class="title">{{ ev.name }}</p>
                  <a id="trash" @click="deleteEvenement(ev.id)">
                    <font-awesome-icon class="text-primary" icon="fa-solid fa-trash"/>
                  </a>
                </div>
                <p>Date: {{ formatDate(ev.date) }}</p>

                <router-link
                    class="icon-style"
                    :to="{ name: 'list-user-evenement-view', params: { event_id: ev.id } }">
                  <p>Clients inscrits: {{ ev.user_count }}</p>
                </router-link>

                <p v-if="ev.notes">Notes: {{ ev.notes }}</p>
              </b-card-text>
            </b-card>
          </b-card-group>
        </div>

      </div>

    </div>
  </main>


</template>


<style scoped lang="scss">
.title {
  font-size: larger;
  font-weight: bold;
  text-transform: capitalize;
}


#trash {
  margin: 0 0 0 auto;
  width: auto;
}

.card-deck .card {
  margin-bottom: 15px;
}

@media(min-width: 576px) {
  .card-deck .card {
    min-width: 28%;
    max-width: 28%;
  }

  a {
    margin: 10px 0;
  }
}

</style>

<script>

import {delete_evenement, get_all_events} from "@/services/ApiServices";


export default {
  name: 'evenement-view',
  data() {
    return {
      evenements: [],
      error: false,
      msg_alert: ''
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    deleteEvenement(ev_id) {
      delete_evenement(ev_id).then(response => {
        this.evenements = response
      })
    }
  },
  created() {
    get_all_events().then(response => {
      this.evenements = response;
    }).catch(error => {
      this.error = true;
      this.msg_alert = error.message
    })
  }
}
</script>